import React, { Component } from 'react'
import _ from 'lodash'
import { getBelongsToValue, getValue, getAttributeAssociation } from '../../utils/models'
import withValues from '../../hocs/withValues'
import withAttributes from '../../hocs/withAttributes'
import AutoInput from '../AutoInput'

class AutoForm extends Component {
    
    render() {
        return _.keys(this.props.attributes).map((key, index) => {
            let inputProps = {}
            if (this.props.belongsTo) {
                if (this.props.belongsTo.association === key) {
                    inputProps = {
                        value: getBelongsToValue(this.props.model, this.props.belongsTo),
                        hidden: true,
                        dispatch: this.props.belongsTo.dispatch ? this.props.belongsTo.dispatch : null 
                    }

                }
            }

            if (this.props.hasOwnProperty('inputProps') && this.props.inputProps.hasOwnProperty(key)) {
                inputProps = this.props.inputProps[key]
            }

            if (this.props.hasOwnProperty('id')) {
                inputProps.id = this.props.id

                const association = getAttributeAssociation(this.props.model, key)

                if (association) {
                    inputProps.belongsTo = {
                        association,
                        id: this.props.id
                    }
                }
            }

            if (this.props.hasOwnProperty('autoSave')) {
                inputProps.autoSave = this.props.autoSave
            }

            if (this.props.hasOwnProperty('disabled')) {
                inputProps.disabled = this.props.disabled
            }
            if (this.props.attributes[key].hasOwnProperty('disabled')) {
                inputProps.disabled = true
            }
            return (
                <AutoInput
                    key={index}
                    value={getValue(this.props.values, key)}
                    form={this.props.form}
                    model={this.props.model}
                    attribute={key}
                    dispatch={this.props.belongsTo ? this.props.belongsTo.dispatch : null}
                    {...inputProps}
                />
            )
        })
    }

}

export default withValues(withAttributes(AutoForm))



// WEBPACK FOOTER //
// ./src/containers/AutoForm/index.js